module.exports = __webpack_public_path__ + "fonts/DrukCyr-Heavy.b89e4f5f.ttf";